import React, { useContext, useEffect, useMemo } from "react";

import { PasscodeOptions } from "@is/constants";
import { ViewStateContext } from "@is/contexts";
import StoreFavoritesView from "@is/features/SettingsDrawer/StoreFavoritesView";
import { useConfiguration, useStoreDevice } from "@is/hooks";
import useScanner from "@is/hooks/scanner/useScanner";
import { TrackingEventTypes, trackEvent } from "@is/services/EventTracking";

import IFramePage from "../../IFramePage";
import PasscodeView from "../../PasscodeView";
import SettingsPage from "../../SettingsPage";

const useManageSettingsDrawerContent = () => {
  const {
    showIFramePage,
    showPasscodeView,
    showStoreFavoritesView,
    updateViewState,
  } = useContext(ViewStateContext).settings;

  const { showStyleNotExistModal, handleCloseModal } = useScanner();

  const { data: storeInfo } = useStoreDevice();

  const { staffDashboard } = useConfiguration();

  const passcode = useMemo(() => {
    if (!staffDashboard || !storeInfo) return [];

    if (staffDashboard.passcodeOption === PasscodeOptions.CUSTOM) {
      return staffDashboard.customPasscode.split("");
    }

    if (staffDashboard.passcodeOption === PasscodeOptions.STOREID) {
      return storeInfo.storeId.split("");
    }

    return [];
  }, [staffDashboard, storeInfo]);

  const content = useMemo(() => {
    if (showPasscodeView) {
      return <PasscodeView maskedPasscode={passcode} />;
    }

    if (showIFramePage) {
      return <IFramePage />;
    }

    if (showStoreFavoritesView) {
      return <StoreFavoritesView />;
    }

    return <SettingsPage storeInfo={storeInfo} />;
  }, [
    passcode,
    showIFramePage,
    showPasscodeView,
    showStoreFavoritesView,
    storeInfo,
  ]);

  useEffect(() => {
    if (staffDashboard?.passcodeOption === PasscodeOptions.DISABLED) {
      updateViewState({ showPasscodeView: false });
    }
  }, [staffDashboard]);

  useEffect(() => {
    if (!showPasscodeView) {
      trackEvent({
        eventType: TrackingEventTypes.StaffPageOpened,
        data: {},
      });
    }
  }, [showPasscodeView]);

  useEffect(() => {
    if (
      staffDashboard?.passcodeOption === PasscodeOptions.CUSTOM ||
      staffDashboard?.passcodeOption === PasscodeOptions.STOREID
    ) {
      trackEvent({
        eventType: TrackingEventTypes.StaffPasscodePageOpened,
        data: {},
      });
    }
  }, [staffDashboard]);

  return {
    showStyleNotExistModal,
    handleCloseModal,
    content,
  };
};

export default useManageSettingsDrawerContent;
